import React from 'react';
import { Link } from 'react-router-dom';

import { ListItem, ListItemButton, ListItemContent, ListItemDecorator, Typography } from '@mui/joy';
import { SxProps } from '@mui/material';

interface SideNavLinkItemProps {
  icon: React.ReactNode;
  title: string;
  toLink: string;
  isActive?: boolean;
  palette: 'dark' | 'light';
}

const SideNavLinkItem: React.FC<SideNavLinkItemProps> = ({ icon, title, toLink, isActive = false, palette }) => {
  const localIcon = icon || null;
  const sxStyle: SxProps = {
    margin: '0'
  };
  const color = palette === 'dark' ? 'text.secondary' : 'text.primary';
  if (isActive) {
    sxStyle.backgroundColor = 'neutral.plainActiveBg';
  }
  return (
    <ListItem sx={{ padding: '0' }}>
      <ListItemButton component={Link} sx={sxStyle} to={toLink}>
        <ListItemDecorator>{localIcon}</ListItemDecorator>
        <ListItemContent>
          <Typography
            level='body-md'
            sx={{
              color: isActive ? 'text.primary' : color
            }}
          >
            {title}
          </Typography>
        </ListItemContent>
      </ListItemButton>
    </ListItem>
  );
};

export default SideNavLinkItem;
